import { render, staticRenderFns } from "./SummaryBrandCombineYear.vue?vue&type=template&id=017e60d6"
import script from "./SummaryBrandCombineYear.vue?vue&type=script&lang=js"
export * from "./SummaryBrandCombineYear.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrandCombineYear.vue?vue&type=style&index=0&id=017e60d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports